import { Chart as ChartJs, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJs.register(ArcElement, Tooltip, Legend);

function Scrimmage(props) {
	const data = {
		// labels: ["Established", "Contested", "Non-Germane"],
		labels: ["Established", "Contested"],
		datasets: [
			{
				label: "Votes",
				// data: [props.established, props.contested, props.nonGermane],
				data: [props.established, props.contested],
				// backgroundColor: ["#129BFB", "#FF0000", "#8E8D8A"],
				backgroundColor: ["#129BFB", "#FF0000"],
				// borderColor: ["#129BFB", "#FF0000", "#8E8D8A"],
				borderColor: ["#129BFB", "#FF0000"],
				borderWidth: 1,
			},
		],
	};

	// const total = props.established + props.contested + props.nonGermane;
	const total = props.established + props.contested;
	// These calculations have the possibility of NaN if there are 0 votes. Return 0 if there are no votes
	const establishedPc = Math.round((props.established/total) * 100) || 0;
	const contestedPc = Math.round((props.contested/total) * 100) || 0;
	// const nonGermanePc = Math.round((props.nonGermane/total) * 100) || 0;

	return (
		<div className="w-2/6 rounded-lg shadow-lg pb-2 hidden lg:block">
			<h2 className="mb-1 text-2xl font-bold text-center text-gray-800">Scrimmage Score</h2>
			<div className="flex gap-4 justify-center ">
				<span className="text-established-blue">{establishedPc}% Established</span>
				<span className="text-contested-red">{contestedPc}% Contested</span>
				{/* <span className="text-germane-gray">{nonGermanePc}% Non-Germane</span> */}
			</div>

			<div>
				<Doughnut data={data} width={200} height={300} options={{ maintainAspectRatio: false }} />
			</div>
		</div>
	);
}

export default Scrimmage;
